import { FC } from "react";

export interface SnipeDetailsGridProps {
    price: string | number;
    priceTrend?: "up" | "down" | "none";
    marketCap: number | string;
    age: number | string;
}

const SnipeDetailsGrid: FC<SnipeDetailsGridProps> = ({ price, priceTrend, marketCap, age }) => {
    return (
        <div className="grid grid-cols-3 mb-4">
            <div>
                <div className="text-gray-300 text-sm">Price</div>
                <div
                    className={`flex items-center ${priceTrend === "up" ? "text-green-400" : priceTrend === "down" ? "text-red-500" : ""}`}
                >
                    <span>{price}</span>
                    {priceTrend === "up" && (
                        <svg className="h-3 w-3 ml-1" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M5 15l7-7 7 7"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    )}
                    {priceTrend === "down" && (
                        <svg className="h-3 w-3 ml-1" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M19 9l-7 7-7-7"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    )}
                </div>
            </div>
            <div>
                <div className="text-gray-300 text-sm">MCap</div>
                <div>{marketCap}</div>
            </div>
            <div>
                <div className="text-gray-300 text-sm">Age</div>
                <div>{age}</div>
            </div>
        </div>
    );
};

export default SnipeDetailsGrid;
